import React from 'react';
import autoBind from 'react-autobind';

import GridFilterBase from './grid.filter.base';
import { Checkbox, Space } from 'antd';

class GridFilter extends GridFilterBase {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  mountInputs() {
    let { column } = this.props;
    if (!column.inputs || column.inputs.length == 0) {
      if (column.array && column.array.length > 0) {
        column.inputs = column.array.map((item) => {
          return {
            type: 'lista',
            operation: 'lista',
            title: item.label,
            value: item.value,
            icon: item.icon,
            iconCss: item.iconCss,
            check: item.checkItem ? item.checkItem : false,
            arrayType: column.arrayType,
          };
        });
        this.updateContextColumn(column);
      }
    }
  }

  updateIcon(column) {
    column.isFiltered = column.inputs.some((x) => x.check);
  }

  handleChangeValue(index) {
    let { column } = this.props;
    return (e) => {
      column.inputs[index].check = e.target.checked;
      this.updateContextColumn(column);
    };
  }

  get isAllChecked() {
    let { column } = this.props;
    return !column.inputs.some((x) => !x.check);
  }

  checkAll(e) {
    let { checked } = e.target;
    let { column } = this.props;
    column.inputs.forEach((x) => {
      x.check = checked;
    });
    this.updateContextColumn(column);
  }

  render() {
    const { column } = this.props;
    const { inputs } = column;

    if (!inputs) return null;

    return (
      <Space className="filterContainerLista" size={2} direction="vertical">
        <Checkbox className="filterCheckboxLista" checked={this.isAllChecked} onChange={this.checkAll}>
          {'Selecionar Todos'}
        </Checkbox>

        {inputs.map(this.renderInput)}
      </Space>
    );
  }

  renderInput(input, index) {
    return (
      <Checkbox
        key={index}
        className="filterCheckboxLista"
        checked={input.check}
        onChange={this.handleChangeValue(index)}
      >
        {input.icon && <i className={`${input.icon} ${input.iconCss || ''} mr-1`} />}
        {input.title}
      </Checkbox>
    );
  }
}

export default GridFilter;
